import { injectable, inject } from 'inversify';
import JsonRpcDispatcher, { interceptors } from '@dealroadshow/json-rpc-dispatcher';
import type { IAdapter } from '@dealroadshow/json-rpc-dispatcher';
import Container from '@framework/di/Container';
import addSessionData from '@users/session/interceptors/rpc/addSessionData';
import checkSession from '@users/session/interceptors/rpc/checkSession';
import parseWrappedError from '@framework/api/Rpc/parseWrappedError';

@injectable()
export class SocketDispatcherFactory {
  constructor(@inject(Container) private readonly container: Container) {}

  create(adapter: IAdapter): JsonRpcDispatcher {
    return new JsonRpcDispatcher(adapter)
      .interceptRequest(addSessionData(this.container))
      .interceptResponse(checkSession(this.container))
      .interceptResponse(parseWrappedError())
      .interceptResponse(interceptors.response.transformErrorToException);
  }
}
